/**
 * Cyber-Minimal MetricCard Component
 * 
 * @param {Object} props
 * @param {string} props.label - Metric label
 * @param {string | number} props.value - Metric value
 * @param {string} props.unit - Optional metric unit
 * @param {string} props.trend - Optional trend ('up' | 'down' | 'neutral')
 * @param {string} props.description - Optional tooltip description shown on hover
 */
export function createMetricCard({ label, value, unit = '', trend = 'neutral', description = '' }) {
  const container = document.createElement('div');
  container.className = `cm-metric-card cm-metric-card--${trend} notranslate`;
  container.setAttribute('translate', 'no');

  // Add native tooltip for user education
  if (description) {
    container.title = description;
    container.style.cursor = 'help';
  }

  const labelEl = document.createElement('div');
  labelEl.className = 'cm-metric-card__label';
  labelEl.textContent = label;

  const valueContainer = document.createElement('div');
  valueContainer.className = 'cm-metric-card__value-container';

  const valueEl = document.createElement('span');
  valueEl.className = 'cm-metric-card__value';
  valueEl.textContent = value;

  valueContainer.appendChild(valueEl);

  if (unit) {
    const unitEl = document.createElement('span');
    unitEl.className = 'cm-metric-card__unit';
    unitEl.textContent = unit;
    valueContainer.appendChild(unitEl);
  }

  container.appendChild(labelEl);
  container.appendChild(valueContainer);

  return container;
}
